<section class="mbfs-main-nav hidden">
  <div class="mbfs-main-nav-overlay" [class.sticky]="isSticky" (click)="onClickOverly($event)"></div>
  <div class="mbfs-main-nav-content" id="mbfs-main-nav-content">
      <div class="mbfs-main-nav-links" (linkClickListener)="onClickOverly($event)"></div>
  </div>
</section>
